import { render, staticRenderFns } from "./current-account-container.vue?vue&type=template&id=f6356102"
import script from "./current-account-container.vue?vue&type=script&lang=ts"
export * from "./current-account-container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports